import { ProductTheme } from "../domain/theme/product.theme.ts";
import { apiClient } from '../domain/clients/api.client.ts';

export default (async () => {
  await apiClient.login();
  const product = new ProductTheme();

  product.mount();
  
  return true;
})();